import { render, staticRenderFns } from "./GrayCloseButton.vue?vue&type=template&id=6a0b64ae&scoped=true&"
import script from "./GrayCloseButton.vue?vue&type=script&lang=js&"
export * from "./GrayCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./GrayCloseButton.vue?vue&type=style&index=0&id=6a0b64ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b64ae",
  null
  
)

export default component.exports